import styled  from 'styled-components';
import { fontGraphie } from '../../../../fonts/mixin';
import { device } from '../../../utils/responsive_utilities';
import { lightRed, maroon } from '../../loggedout/shared-styles/Colors';
import FontGraphie from '../../loggedout/shared-styles/graphieFont';

export const Container = styled.div`
  position: fixed;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  top: 8rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 2.7rem 1.5rem;
  background: ${lightRed};
  border-radius: 1rem;
  border-left: 0.7rem solid ${maroon};
  ${FontGraphie(1.8,1.2,4)};
  
  @media ${device.TabletLandscape}{
    width: 69rem;
  }
  
  @media ${device.Tablet}{
    width: 62rem;
    ${FontGraphie(1.6,1,4)};
    padding: 2.4rem 2.1rem
  }

  @media ${device.PhoneTabletLandscape}{
    min-width: 42rem;
    ${FontGraphie(1.6,1.2,4)};
    padding: 1rem 1rem;
  }

  @media ${device.PhonePortrait}{
    width: 90%;
    padding: 2.8rem 1.2rem;
    ${fontGraphie(1.6,1.4,4)};
  }
`;
export const InfoIcon = styled.div`
  height: 2.6rem;
  width: 2.6rem;
  display: inline-block;
  margin-right: 1.5rem;
  flex-shrink: 0;
  align-self: flex-start;
  >img{
    width: 100%;
    height: 100%;
  }
  @media ${device.Tablet}{
    height: 2.3rem;
    width: 2.3rem;
  }
  @media ${device.PhoneTabletLandscape}{
    height: 2rem;
    width: 2rem;
  }
  @media ${device.PhonePortrait}{
    height: 2rem;
    width: 2rem;
  }
`;
export const ErrorText = styled.div`
  display: inline-block;
  text-align: left;
`;

export const Cross = styled.div`
  margin: 0 0.5rem 0 4.2rem;
  height: 1.6rem;
  width: 1.6rem;
  flex-shrink: 0;
  cursor: pointer;

  >img{
    width: 100%;
    height: 100%;
  }

  @media ${device.Tablet}{
    height: 1.5rem;
    width: 1.5rem;
    margin: 0 0.2rem 0 3.9rem;
  }

  @media ${device.PhoneTabletLandscape}{
    align-self: self-start;
    margin-top: 0.5rem;
  }

  @media ${device.PhonePortrait}{
    height: 1.5rem;
    width: 1.5rem;
    margin: 0 1.5rem 0 1rem;
    align-self: self-start;
  }
`